/*
 * Created on Fri 10/29/21
 * Created By Pankaj Dhurandhar
 * Copyright (c) 2021 synsoft global
 */

import { AddToast } from "react-toast-notifications";
import { messageObject } from ".";

/*
 * this function is used for set access token of use
 */
export function setToken(token: string, callBackFn: () => void): void {
  localStorage.setItem("token", token);
  localStorage.setItem("id", parseJWTGetUserDetials(token).id);
  localStorage.setItem("expiration time", parseJWTGetUserDetials(token).exp);
  setTimeout(() => {
    callBackFn();
  }, 100);
}

interface ITokenDetails {
  id: string;
  exp: string;
  iat: string;
}

function parseJWTGetUserDetials(token): ITokenDetails {
  const base64Payload = token.split(".")[1];
  const payload = Buffer.from(base64Payload, "base64");
  return {
    id: JSON.parse(payload.toString()).id,
    exp: JSON.parse(payload.toString()).exp,
    iat: JSON.parse(payload.toString()).iat
  }
}


export const isAuthenticate = (): boolean => {
  const token = localStorage.getItem("token");
  if (token !== null && token !== "" && token !== undefined) {
    return true;
  } else {
    return false;
  }
};

export function logOut(): void {
  if (localStorage.getItem('Fb_Login') === "true") {
    (window as any).FB.getLoginStatus(function (response) {
      (window as any).FB.logout(function (response) {
        localStorage.clear();
        console.log("Logged Out FB!");
      });
    });
  }
  localStorage.clear();
}
export function logoutArtist(): void {
  if (localStorage.getItem('Fb_Login') === "true") {
    (window as any).FB.getLoginStatus(function (response) {
      (window as any).FB.logout(function (response) {
        localStorage.removeItem('artistDetails');
        localStorage.removeItem('isArtistPayment');
        localStorage.removeItem('IsFreeTierEnable');
        console.log("Logged Out FB!");
      });
    });
  }
  localStorage.removeItem('artistDetails');
  localStorage.removeItem('isArtistPayment');
  localStorage.removeItem('IsFreeTierEnable');
}



/**
 * Display Error massages
 *          or
 * User unauthorized then redirect to landing page.
 * @param message
 * @param history
 * @param addToast
 */
export const showToastErrMsgOrRedirectLandingPage = (message: string, history: any, addToast: AddToast): void => {
  if (message === "The current user is not authorized to access this resource.") {
      history.push("/landing-page");
    logOut();
  } else if (message === "Access is denied." || message === null) {
     //
  }
  else {
    addToast(message, {
      appearance: 'error',
      autoDismiss: true,
    });
  }
}


export const showImageUploadErr = (addToast: AddToast): void => {
  addToast(messageObject.uploadImgErr, {
    appearance: 'error',
    autoDismiss: true,
  });
}

export const showSongUploadErr = (addToast: AddToast): void => {
  addToast(messageObject.uploadSongErr, {
    appearance: 'error',
    autoDismiss: true,
  });
}